import { checkTitle, type RuleLabel } from "src/components/guardrailRuleLabels";
import type { GuardrailCheck } from "src/components/RequisitionGuardrailOutcome";

const text = (value: string | null | undefined): string => value?.trim() ?? "";

const failingEffects = (
  checks: GuardrailCheck[] | null | undefined
): GuardrailCheck[] =>
  (checks ?? []).filter((check) => {
    if (check.state === "PASS") {
      return false;
    }
    const effect = check.effect ?? "BLOCK";
    return effect === "BLOCK" || effect === "WARN";
  });

export const failingCheckLabels = (
  checks: GuardrailCheck[] | null | undefined,
  catalogue?: { rules: RuleLabel[]; loaded: boolean }
): string[] =>
  failingEffects(checks).flatMap((check) => {
    const label = checkTitle(
      check,
      catalogue?.rules ?? [],
      catalogue?.loaded ?? false
    );
    return label ? [label] : [];
  });

export const failingCheckSentences = (
  checks: GuardrailCheck[] | null | undefined
): string[] =>
  failingEffects(checks).flatMap((check) => {
    const label = text(check.detail);
    return label ? [label] : [];
  });
